import { useState } from 'react';
import API_ROUTES from './apiRoutes';
import { useFetch } from './useFetch';
import { TemplateModel } from '../Models/TemplateModel';

export const useTemplate = () => {
    const [template, setTemplate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { fetchWithAuth } = useFetch();

    const getToken = () => localStorage.getItem('token');

    const fetchTemplate = async (templateId) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetchWithAuth(API_ROUTES.TEMPLATES.get(templateId), {
                headers: { Authorization: `Bearer ${getToken()}` }
            });
            const data = await response.json();
            setTemplate(TemplateModel.fromJson(data));
        } catch (err) {
            setError('Erro ao carregar template');
            console.error('Error fetching template:', err);
        } finally {
            setLoading(false);
        }
    };

    return { template, loading, error, fetchTemplate };
}; 